export const initialState = {
  specSheet: null,
  skuDetails: null,
  image: null,
  type: null,
  loading: false,
};
